 <template lang='pug'>
  #GPT(style='max-height: calc(100vh);').main-page.GPT-color.page-noScroll.pb-0.position-relative
    loadingOverlay(v-show='loading' message='Loading . . .' :zIndex='999')
    // 標題行 - 隱藏資料夾模式 (一般模式)
    div.d-flex.align-center.px-0.pb-0.px-md-2.pb-md-4(v-if='!folder_mode && isAdmin')
      span.ml-4.mr-6(style='font-weight: 500; font-size: 28px; letter-spacing:0.5px; color:#444;') {{ $t('GPT_MENU.KNOWLEDGE') }}
      v-btn.white--text(@click='showAddDialog' height='40' :ripple='false' color='#14C6DE' depressed)
        v-img.mr-1(src="@/assets/images/add-white-thin.png" max-height="16" max-width="16")
        span(style='font-weight: 500; font-size: 16px;') {{ $t("ADD_KNOWLEDGE.TITLE") }}
    // 標題行 - 啟動資料夾模式
    div.d-flex.align-center.px-0.pb-0.px-md-2.pb-md-4(v-else cols='4' md='6')
      span.ml-4.mr-6(style='font-weight: 700; font-size: 28px;') {{$t('GPT_MENU.KNOWLEDGE')}}
      v-menu(
        v-if='isAdmin'
        v-model='menuOpen'
        offset-y
        bottom
        left
        close-on-content-click
      )
        template(v-slot:activator='{ on, attrs }')
          v-btn.white--text(
            v-bind='attrs'
            v-on='on'
            height='40'
            :ripple='false'
            color='#14C6DE'
            depressed
          )
            v-img.mr-1(src="../assets/images/add-white-thin.png" max-height="16" max-width="16")
            span(style='font-weight: 700; font-size: 16px;') {{$t("ADD_KNOWLEDGE.TITLE")}}
            v-icon.pl-2(size='20') mdi-chevron-down
        v-list(dense)
          v-list-item(@click='createKnowledgeFolder')
            v-list-item-icon.mr-2
              v-img(src="../assets/images/Kb-folder-icon.png" max-height="18" max-width="18" contain)
            v-list-item-title {{$t("ADD_KNOWLEDGE.FOLDER")}}
          v-list-item(@click='onMenuAddKnowledge')
            v-list-item-icon.mr-2
                v-img(src="../assets/images/Kb-folder-Kb-icon.png" max-height="18" max-width="18" contain)
            v-list-item-title {{$t("ADD_KNOWLEDGE.KB")}}      
    // 篩選搜尋區
    div.ma-0.mt-3.pa-0.d-flex.align-center.justify-space-between
      v-row.ma-0.pa-0.d-flex.justify-start
        v-col(cols='2' width='100px').px-0.ml-6
          div(style="position: absolute; margin-top:-22px; font-family: 'Segoe UI'; font-weight: 400; font-size: 12px; color: #444444;") {{$t('GPT_KNOWLEDGE.CATEGORY')}}
          v-select.bg-white(v-model='selectCategory' height='30' dense outlined clearable :placeholder='$t("GPT_KNOWLEDGE.CATEGORY")' :items='category_list' item-value='id' item-text='name')
        v-col(cols='2').px-0.ml-3
          div(style="position: absolute; margin-top:-22px; font-family: 'Segoe UI'; font-weight: 400; font-size: 12px; color: #444444;") {{$t('GPT_KNOWLEDGE.UPDATED_BY')}}
          v-select.bg-white(v-model='selectUpdateby' height='30' dense outlined clearable :placeholder='$t("GPT_KNOWLEDGE.UPDATED_BY")' :items='user_list' item-value='id' item-text='name')
        // 啟動篩選按鈕
        v-col(cols='1').px-0.ml-3.mr-1
          v-btn.white--text(@click='act_search' height='40' :ripple='false' color='#14C6DE' depressed)
            v-img.mr-1(src="../assets/images/search_btn_icon.png" max-height="18" max-width="18")
            span(style='font-weight: 600; font-size: 16px;') {{$t('GENERAL.SEARCH')}}
        // 重置選擇按鈕
        v-col(cols='1').px-0.ml-0
          v-btn(text height='40' @click='refresh')
            v-img.mr-1(src="../assets/images/refresh.png" max-height="16" max-width="16")
            span(style="font-family: 'Segoe UI'; font-weight: 700; font-size: 16px; color: #14C6DE;") {{$t('GENERAL.REFRESH')}}
        // 關鍵字搜尋 
        v-col(cols='1').px-0.ml-1
          div.lib_search_bar_style
            v-text-field(v-model='libname_search' flat dense append-icon='icon-search' rounded outlined style='width:200px;' hide-details)
    //-  breadcrumbs + view toggle
    div.knowledge-folder-breadcrumbs.ma-0.mt-3.mb-3.pa-0.d-flex.align-center.justify-space-between
      v-breadcrumbs.ml-2.py-0(v-if="activeView == 'card' && folder_mode" :items="breadcrumbs" divider="/")
        template(v-slot:item="{ item }")
          v-breadcrumbs-item(:disabled="item.disabled" class="cursor-pointer" @click="onBreadcrumbClick(item)") {{ item.text }}
      v-spacer
      v-btn-toggle.view-toggle.mr-4(v-if='folder_mode' v-model="activeView" mandatory dense)
        v-btn.view-toggle__btn(value="tree" :ripple="false" depressed)
          v-img.view-toggle__icon(src="../assets/images/knowledge_folder_icon_list.svg" max-height="18" max-width="18") 
        v-btn.view-toggle__btn(value="card" :ripple="false" depressed)
          v-img.view-toggle__icon(src="../assets/images/knowledge_folder_icon_card.svg" max-height="18" max-width="18") 
    //- Content
    div.mx-6.mb-4.pa-4.knowledge-folder-tab(style="height: calc(100vh - 120px); overflow:auto; border-radius:8px;")
      // 列表模式
      div(v-if="activeView == 'tree'")
        #KnowledgeTree(style="padding: 10px;")
          treeselect(
            ref="ts"
            v-if="!loading"
            v-model="selectedTreeId"
            :options="treeOptions"
            :normalizer="normalizer"
            :disable-branch-nodes="false"
            :always-open="true"
            :default-expand-level="0"
            noResultsText="No data available"
            :matchKeys="match_keys"
            :disableFuzzyMatching="true"
            :multiple="false"
            :placeholder="$t('FOLDER_LOCATION_PICKER.PLACEHOLDER') || 'Select...'"
          )
            template(v-slot:option-label="{ node }")
              v-hover(v-slot="{ hover }")
                .kt-row(:title="node.raw && node.raw.name" @dblclick.stop.prevent="expandFolder(node)")
                  //- 左欄：icon + name
                  .kt-col.kt-col--name
                    template(v-if="node.raw && node.raw.type=='library'")
                      v-img.mr-2(src="@/assets/images/knowledge_select.svg" max-height="18" max-width="18")
                    template(v-else)
                      v-img.mr-1(src="@/assets/images/folder-btn.svg" max-height="20" max-width="20")
                    span.kt-name {{ node.raw?.name }}
                  .kt-actions
                    v-menu(v-if='isAdmin||node.raw.perm.can_edit' offset-y left :close-on-content-click="true")
                      template(v-slot:activator="{ on, attrs }")
                        v-btn.kt-more-btn( icon v-bind="attrs" v-on="on" @click.stop.prevent)
                          v-img.img-mobile-size(src="@/assets/images/mdi--dots-horizontal.svg")
                      v-list(dense)
                        v-list-item(v-if='node.raw.perm.can_edit' @click.stop="onFolderEdit(node.raw)")
                          v-img.mx-1(src="../assets/images/edit.png" max-height="16" max-width="16")
                          v-list-item-title.mr-2(color="#444") {{$t('GENERAL.EDIT')}}
                        v-list-item(v-if='isAdmin' @click.stop="onFolderDelete(node.raw)")
                          v-list-item-icon.mx-0
                            v-icon(size="16" color="#444") icon-remove
                          v-list-item-title.mr-2(color="#444") {{$t('GENERAL.DELETE')}}
      // 卡片模式 (傳統模式)
      div(v-else)
        div.section-title.mb-2.mr-2.ml-4(v-if='folder_mode' style='color:rgb(68,68,68); font-weight: 600; font-size: 16px;') {{$t("GPT_KNOWLEDGE.KNOWLEDGE_FOLDER")}}
        div.d-flex.flex-wrap.gap-8(v-if='folder_mode')
          v-col.px-0.mr-10(class="mt-1" cols="1" v-for="(item,index) in folderNodes" :key='item.id').pl-0.pt-0
            v-hover()
              template(v-slot:default="{ hover }")
                div.kb-card.kb-card--folder(
                  :class="hover ? 'UX-folder-card-hover' : ''"
                  @dblclick="openFolder(item)"
                )
                  div.kb-card__menu(v-show="hover" @click.stop)
                    v-menu(v-if='isAdmin||item.perm.can_edit' offset-y bottom close-on-content-click)
                      template(v-slot:activator="{ on, attrs }")
                        v-btn(icon='icon' v-bind="attrs" width='24' height='24' v-on="on" @click.stop)
                          v-img.img-mobile-size(src="@/assets/images/mdi--dots-horizontal.svg")
                      v-list(dense)
                        v-list-item(v-if='item.perm.can_edit' @click.stop="onFolderEdit(item)")
                          v-img.mr-4(src="@/assets/images/edit.png" max-height="20" max-width="20")
                          span {{$t("GENERAL.EDIT")}}
                        v-list-item(v-if='isAdmin' @click.stop="onFolderDelete(item)")
                          v-icon.mr-2(size="18" color="#444") icon-remove
                          span {{$t("GENERAL.DELETE")}}
                  v-card-actions.kb-card__icon
                    v-img.mr-1(src="@/assets/images/folder-btn.svg" max-height="60" max-width="60")
                  v-card-text.kb-card__name.pa-0(:title="item.name") {{ item.name }}
        v-divider.mt-0.ml-4(v-if='folder_mode')
        div.section-title.my-2.mr-2.ml-4(v-if='folder_mode' style='color:rgb(68,68,68); font-weight: 600; font-size: 16px;') {{$t("GPT_KNOWLEDGE.KNOWLEDGE")}}
        div.d-flex.flex-wrap.mr-6
          v-col(class="mt-1" cols="auto" v-for="(data,index) in kbNodes" :key='data.id').pl-0.pt-0
            v-hover
              template(v-slot:default="{ hover }")
                div.UX-knowledges-card(:class="hover ? 'UX-knowledges-card-hover' : ''")
                  // icon + 標題
                  v-card-title.pa-0.ml-4.mt-1.d-flex.align-center(style="height:48px; width:298px;")
                    div.pa-0.ma-0.d-flex.align-center.justify-start
                      v-img(id='rounded-card' src="../assets/images/book1.png" class="white--text align-end"  width="36px" height="32px" style="margin:6px 6px 4px 0px;")
                      p.ma-0.UX-knowledges-card-title(:title='data.name') {{ data.name }}
                  // 描述行
                  v-card-text.mt-1.pa-0
                    div.pa-0.ma-0.ml-4
                      p.ma-0.UX-knowledges-card-descriptions(:title='data.data.description') {{data.data.description}}
                  // 工具行
                  div(style='width:298px; height:28px').mt-2.mx-auto.pa-0.d-flex.align-center.justify-space-between
                    // 開關知識庫
                    v-col.px-0.d-flex.align-center.justify-center
                      label.UX-switch.mr-1
                        input(v-model='data.data.active' type="checkbox" @click='openKnowledge(data)')
                        div(class="UX-slider round")
                      span(v-if='data.data.active' style='color:#888888; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.OPEN_LIB")}}
                      span(v-else style='color:#888888; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.CLOSE_LIB")}}
                    // 編輯知識庫
                    v-col.d-flex.align-center.justify-center
                      v-btn.pa-0(:href='"/upgpt/Knowledges/"+data.id' :target='openKnowledgeNewTab ? "_blank" : null' plain  ripple style='width:40px; height:28px;')
                        v-img.mr-1(src="../assets/images/edit.png" max-height="16" max-width="16")
                        div(style='color:#222222; font-weight: 500; font-size: 14px;') {{$t("GENERAL.EDIT")}}
                    // 刪除知識庫
                    v-col
                      v-btn(v-if='isAdmin' @click='onDelete(data.id)' plain style='width:40px; height:28px;')
                        v-icon(size='16' color='#222222') icon-remove
                        div(style='color:#222222; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.DELETE_SIMPLE")}}
                  v-divider.ma-0.mt-1.mb-1.ml-3.mr-3
                  // 相關資料區
                  div.d-flex.align-center.justify-space-between
                    v-card-text.pa-0.ma-0.ml-4(style='width:210px; max-height: 42px;')
                      p.mt-1.mb-0(:title='data.category' style='color:#888888; font-weight: 400; font-size: 12px;') {{$t("GPT_KNOWLEDGE.CATEGORY")}} : 
                        span(style='color:#666666; font-weight: 400; font-size: 12px;') {{data.data.category}}
                      p.mt-1.mb-2(:title='data.docs_count' style='color:#888888; font-weight: 400; font-size: 12px;') {{$t("GPT_KNOWLEDGE.DOCS")}} : 
                        span(style='color:#666666; font-weight: 400; font-size: 12px;') {{data.data.docs_count}}
                    v-card-text.pa-0.ma-0(style='width:210px; max-height: 42px;')
                      div.pa-0.ma-0.d-flex.align-center.justify-start
                        p.mt-1.mb-0(:title='data.data.robots_count' style='color:#888888; font-weight: 400; font-size: 12px;') {{$t("GPT_KNOWLEDGE.ROBOTS")}} : 
                          v-avatar.ma-0.mr-1.knowledges-avatar-UX(v-for='(item,index) in data.data.robots.slice(0, 5)' :key='index' :color="bot_background_colors[index]" :title='item.bot_name' v-if='index<3')
                            div(style='color:#666666; font-weight: 500; font-size: 14px;') {{ item.bot_name[0] }}
                        div.pa-0.ma-0.mt-2(v-if='data.data.robots_count>3' style='color:#666666; font-weight: 400; font-size: 12px;') +{{data.data.robots_count - 3}}
                      div.mt-1.mb-2.d-flex.align-center.justify-start(:title='data.data.updated_by.last_name+""+data.data.updated_by.first_name')
                        span.mr-1(style='color:#888888; font-weight: 400; font-size: 12px;') {{$t("GPT_KNOWLEDGE.UPDATED_BY")}} :  
                        span.updateby-user(style='color:#666666; font-weight: 400; font-size: 12px;') {{data.data.updated_by.last_name}} {{data.data.updated_by.first_name}}
    //- // 知識庫卡片
    //- #page-inner.scroll-x.pb-0(style='max-height: calc(84vh) !important;')
    //-   div.card-area(v-if='!loading' style='min-height: calc(79vh) !important; max-height: calc(79vh) !important; overflow: auto;')
    //-       v-container.upgpt-container(max-content)
    //-        v-row.d-flex.align-center.justify-start.pt-2(style="margin-left:11px;")
    //-         v-col(class="mt-1" cols="auto" v-for="(data,index) in filter_knowledges_list" :key='data.id').pl-0.pt-0
    //-           v-hover
    //-             template(v-slot:default="{ hover }")
    //-               div.UX-knowledges-card(:class="hover ? 'UX-knowledges-card-hover' : ''")
    //-                 // icon + 標題
    //-                 v-card-title.pa-0.ml-4.mt-1.d-flex.align-center(style="height:48px; width:298px;")
    //-                   div.pa-0.ma-0.d-flex.align-center.justify-start
    //-                     v-img(id='rounded-card' src="../assets/images/book1.png" class="white--text align-end"  width="36px" height="32px" style="margin:6px 6px 4px 0px;")
    //-                     p.ma-0.UX-knowledges-card-title(:title='data.name') {{ data.name }}
    //-                 // 描述行
    //-                 v-card-text.mt-1.pa-0
    //-                   div.pa-0.ma-0.ml-4
    //-                     p.ma-0.UX-knowledges-card-descriptions(:title='data.description') {{data.description}}
    //-                 // 工具行
    //-                 div(style='width:298px; height:28px').mt-2.mx-auto.pa-0.d-flex.align-center.justify-space-between
    //-                   // 開關知識庫
    //-                   v-col.px-0.d-flex.align-center.justify-center
    //-                     label.UX-switch.mr-1
    //-                       input(v-model='data.active' type="checkbox" @click='openKnowledge(data)')
    //-                       div(class="UX-slider round")
    //-                     span(v-if='data.active' style='color:#888888; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.OPEN_LIB")}}
    //-                     span(v-else style='color:#888888; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.CLOSE_LIB")}}
    //-                   // 編輯知識庫
    //-                   v-col.d-flex.align-center.justify-center
    //-                     v-btn.pa-0(:href='"/upgpt/Knowledges/"+data.id' plain  ripple style='width:40px; height:28px;')
    //-                       v-img.mr-1(src="../assets/images/edit.png" max-height="16" max-width="16")
    //-                       div(style='color:#222222; font-weight: 500; font-size: 14px;') {{$t("GENERAL.EDIT")}}
    //-                   // 刪除知識庫
    //-                   v-col
    //-                     v-btn(v-if='isAdmin' @click='onDelete(data.id)' plain style='width:40px; height:28px;')
    //-                       v-icon(size='16' color='#222222') icon-remove
    //-                       div(style='color:#222222; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.DELETE_SIMPLE")}}
    //-                 v-divider.ma-0.mt-1.mb-1.ml-3.mr-3
    //-                 // 相關資料區
    //-                 div.d-flex.align-center.justify-space-between
    //-                   v-card-text.pa-0.ma-0.ml-4(style='width:210px; max-height: 42px;')
    //-                     p.mt-1.mb-0(:title='data.category' style='color:#888888; font-weight: 400; font-size: 12px;') {{$t("GPT_KNOWLEDGE.CATEGORY")}} : 
    //-                       span(style='color:#666666; font-weight: 400; font-size: 12px;') {{data.category}}
    //-                     p.mt-1.mb-2(:title='data.docs_count' style='color:#888888; font-weight: 400; font-size: 12px;') {{$t("GPT_KNOWLEDGE.DOCS")}} : 
    //-                       span(style='color:#666666; font-weight: 400; font-size: 12px;') {{data.docs_count}}
    //-                   v-card-text.pa-0.ma-0(style='width:210px; max-height: 42px;')
    //-                     div.pa-0.ma-0.d-flex.align-center.justify-start
    //-                       p.mt-1.mb-0(:title='data.robots_count' style='color:#888888; font-weight: 400; font-size: 12px;') {{$t("GPT_KNOWLEDGE.ROBOTS")}} : 
    //-                         v-avatar.ma-0.mr-1.knowledges-avatar-UX(v-for='(item,index) in data.robots.slice(0, 5)' :key='index' :color="bot_background_colors[index]" :title='item.bot_name' v-if='index<3')
    //-                           div(style='color:#666666; font-weight: 500; font-size: 14px;') {{ item.bot_name[0] }}
    //-                       div.pa-0.ma-0.mt-2(v-if='data.robots_count>3' style='color:#666666; font-weight: 400; font-size: 12px;') +{{data.robots_count - 3}}
    //-                     div.mt-1.mb-2.d-flex.align-center.justify-start(:title='data.updated_by.last_name+""+data.updated_by.first_name')
    //-                       span.mr-1(style='color:#888888; font-weight: 400; font-size: 12px;') {{$t("GPT_KNOWLEDGE.UPDATED_BY")}} :  
    //-                       span.updateby-user(style='color:#666666; font-weight: 400; font-size: 12px;') {{data.updated_by.last_name}} {{data.updated_by.first_name}}
    //-                       //- v-avatar.knowledges-avatar-28(color="aliceBlue" :title='data.updated_by.last_name+""+data.updated_by.first_name')
    //-                       //-   span.span(v-if="data.updated_by.usersetting.photo === ''") {{ data.updated_by.last_name }}
    //-                       //-   img(v-else :src="data.updated_by.usersetting.photo" :alt='data.updated_by.usersetting.last_name')
                      
    v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitMessageDialog(false)' @keydown.enter='onEmitMessageDialog(true)')
      message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
    v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
      success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
    v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
      error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
    v-dialog(v-model='addDialog' width='480' content-class='statusDialog' v-if='addDialog')
      add-dialog(:parentPath="addDialogParentPath" :parentFolder="addDialogParent"  @emitAddDialog='onEmitAddDialog')
    v-dialog(v-model='addKBFolderDialog' width='480' content-class='statusDialog' v-if='addKBFolderDialog')
      add-folder-dialog(:parentPath="addFolderDialogParentPath" :parentFolder="addFolderDialogParent" @emitAddFolderDialog='onEmitAddFolderDialog')
    v-dialog(v-model='editKBFolderDialog' width='480' content-class='statusDialog' v-if='editKBFolderDialog')
      edit-folder-dialog(:folder='editingKBFolder' @emitEditFolderDialog='onEmitEditFolderDialog' )
</template>

<script>
import loadingOverlay from "@/components/Common/loadingOverlay";
import messageDialog from "@/components/Dialog/messageDialog";
import successDialog from "@/components/Dialog/successDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import addDialog from "@/components/GPT_Dialog/Knowledge/addKnowledge";
import addFolderDialog from "@/components/GPT_Dialog/Knowledge/addKnowledgeFolder";
import editFolderDialog from "@/components/GPT_Dialog/Knowledge/editKnowledgeFolder";
import i18n from '/common/plugins/vue-i18n.js';
import KnowledgeLibraryService from "../services/KnowledgeLibraryService";
import PersonalSettingService from "@/services/PersonalSettingService";
import PreferenceService from "@/services/PreferenceService";
import AiBotsService from "../services/AiBotsService";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    loadingOverlay,
    messageDialog,
    successDialog,
    errorDialog,
    addDialog,
    addFolderDialog,
    editFolderDialog,
    Treeselect,
  },
  data() {
    return {
      // other
      loading:false,
      isDelete:false,
      openKnowledgeNewTab: false,
      // Dialog
      addDialog:false,
      addKBFolderDialog:false,
      editKBFolderDialog:false,
      editingKBFolder: null,
      messageDialog: false,
      message: "",
      successDialog: false,
      successMessage: "",
      errorDialog: false,
      errorMessage: "",
      addDialogParent: null,        // 給 add knowledge 用
      addFolderDialogParent: null,  // 給 add folder 用
      addDialogParentPath: "/",        // 新增：給 add knowledge 用
      addFolderDialogParentPath: "/",  // 新增：給 add folder 用'
      // Data
      isAdmin: false,
      Knowledges_list:[],
      filter_knowledges_list:[],
      botList:[],
      deleteId:null,
      bot_background_colors: ['#9ACFFF', '#F6C2C2', '#DEC5F6', '#9ACFFF', '#F6C2C2', '#DEC5F6' ],
      user_list:[],
      category_list: [],
      selectCategory: null,
      selectUpdateby: null,
      libname_search:'',
      menuOpen: false,
      activeView: "tree", // 'tree' | 'card'
      breadcrumbs: [
        { text: i18n.t('ADD_KNOWLEDGE.KB'), id: "root", disabled: true },
      ],
      selectedTreeId: null,
      treeOptions: [],
      cardNode: [],
      rootCardNodes: [],
      currentFolderId: "root",
      delMode: null,
      deleteFolderData: {},
      match_keys: ["path", "id"],
      nodeMap: new Map(),
      folder_mode: false,
    };
  },
  async created() {
    this.loading = true;
    this.get_upgpt_setting();
    this.checkAdmin();
    this.getKnowledgeOpenNewTab();
    await this.getBotList();
    await this.getListData();
    await PersonalSettingService.getUpGPTUserDetail().then(response => {
      if (response.data.userList.length > 0) {
        let temp_arr = [];
        let temp_data = {};
        let user_data = response.data.userList;
        user_data.filter(el => {
          temp_data = {};
          if(el.is_active == true){
            temp_data['id'] = el.id;
            temp_data['name'] = el.last_name+' '+el.first_name;
            temp_arr.push(temp_data);
          }
        });
        this.user_list = temp_arr
      }
    })
    .catch((response) => {
        this.showErrorDialog(response);
    });

    this.loadRoot();
    this.loading = false;
  },
  destroyed() {
  },
  methods: {
    async get_upgpt_setting(){
      let setting = await this.upgpt_image_func_setting();
      this.folder_mode = setting['knowledge_folder'];
      if (this.folder_mode){
        this.activeView = 'tree';
      } else {
        this.activeView = 'card';
      }
    },
    isEmptyFilterValue(v) {
      return v === null || v === undefined || v === "";
    },
    getNodeName(node) {
      if (!node) return "";
      return (
        node.name
      );
    },
    getLibraryCategory(node) {
      // card view knowledge object: data.data.category
      // folder tree node may not have it
      return node?.data?.category ?? node?.category ?? node?.raw?.category ?? null;
    },
    getLibraryUpdatedById(node) {
      // card view knowledge object: data.data.updated_by.id
      const updatedBy = node?.data?.updated_by ?? node?.updated_by ?? node?.raw?.updated_by;
      return updatedBy && updatedBy.id !== undefined ? updatedBy.id : null;
    },
    matchesLibraryFilters(node) {
      const keyword = (this.libname_search || "").trim();
      const name = this.getNodeName(node);
      if (keyword && !String(name).includes(keyword)) return false;

      if (!this.isEmptyFilterValue(this.selectCategory)) {
        const category = this.getLibraryCategory(node);
        if (category !== this.selectCategory) return false;
      }

      if (!this.isEmptyFilterValue(this.selectUpdateby)) {
        const updatedById = this.getLibraryUpdatedById(node);
        if (updatedById !== this.selectUpdateby) return false;
      }

      return true;
    },
    // Filter a tree while preserving folder hierarchy for Treeselect
    filterTreeForTreeselect(nodes) {
      if (!Array.isArray(nodes)) return [];
      const keyword = (this.libname_search || "").trim();

      const recurse = (list) => {
        const out = [];
        for (const n of list) {
          if (!n) continue;

          const type = n.type || n.raw?.type;
          const name = this.getNodeName(n);

          if (type === "library") {
            if (this.matchesLibraryFilters(n)) out.push(n);
            continue;
          }

          // folder: keep if name matches keyword OR has kept children
          const filteredChildren = recurse(Array.isArray(n.children) ? n.children : []);
          const folderNameMatch = keyword ? String(name).includes(keyword) : true;
          if (folderNameMatch || filteredChildren.length > 0) {
            out.push({ ...n, children: filteredChildren });
          }
        }
        return out;
      };

      return recurse(nodes);
    },
    getNodesForCurrentFolder() {
      if (this.currentFolderId === "root") return Array.isArray(this.rootCardNodes) ? this.rootCardNodes : [];
      const node = this.findNodeById(this.rootCardNodes, this.currentFolderId);
      return Array.isArray(node && node.children) ? node.children : [];
    },
    getParentPath(path) {
      if (typeof path !== "string") return "/";
      const normalized = path.trim().replace(/\/+/g, "/");
      if (!normalized) return "/";
      const idx = normalized.lastIndexOf("/");
      if (idx <= 0) return "/";
      return normalized.slice(0, idx);
    },
    findNodeById(nodes, id) {
      if (!Array.isArray(nodes)) return null;
      for (const node of nodes) {
        if (!node) continue;
        if (node.id === id) return node;
        const found = this.findNodeById(node.children, id);
        if (found) return found;
      }
      return null;
    },
    buildBreadcrumbsToId(id) {
      const base = [{ text: i18n.t('ADD_KNOWLEDGE.KB'), id: "root", disabled: true }];
      if (!id || id === "root") return base;

      // Build path by walking the tree
      const walk = (nodes, targetId, acc) => {
        if (!Array.isArray(nodes)) return null;
        for (const n of nodes) {
          if (!n) continue;
          const next = acc.concat([n]);
          if (n.id === targetId) return next;
          const found = walk(n.children, targetId, next);
          if (found) return found;
        }
        return null;
      };

      const pathNodes = walk(this.rootCardNodes, id, []) || [];
      const crumbs = base.concat(
        pathNodes.map(n => ({
          text: n.name ?? n.system_name ?? String(n.id ?? ""),
          id: n.id,
          disabled: false,
        }))
      );
      if (crumbs.length > 0) {
        crumbs.forEach(c => (c.disabled = false));
        crumbs[crumbs.length - 1].disabled = true;
      }
      if (crumbs.length > 1) crumbs[0].disabled = false;
      return crumbs;
    },
    onBreadcrumbClick(item) {
      if (!item || item.disabled) return;

      if (item.id === "root") {
        this.currentFolderId = "root";
        this.cardNode = Array.isArray(this.rootCardNodes) ? this.rootCardNodes : [];
        this.breadcrumbs = this.buildBreadcrumbsToId("root");
        return;
      }

      const node = this.findNodeById(this.rootCardNodes, item.id);
      this.currentFolderId = item.id;
      this.cardNode = Array.isArray(node && node.children) ? node.children : [];
      this.breadcrumbs = this.buildBreadcrumbsToId(item.id);
    },
    expandFolder(node){
      // Only folder expand
      if(node.raw.type == 'library') {
        this.openKnowledgeDetail(node.id);
      }else if(node.raw.type == 'folder'){
        const currentNode = this.$refs.ts;
        if(currentNode){
          currentNode.toggleExpanded(node);
          return
        }
      }
    },
    checkAdmin(){
      let userJson = window.localStorage.getItem('user');
      let user = JSON.parse(userJson);
      user.is_staff ? this.isAdmin = true : this.isAdmin = false;
    },
    get_403_change_admin_to_staff(){
      let userJson = window.localStorage.getItem('user');
      let user = JSON.parse(userJson);
      user.is_staff = false;
      window.localStorage.setItem('user', JSON.stringify(user));
       window.localStorage.setItem('is_staff', "false");
      this.isAdmin = false;
    },
    async getListData(){
      await KnowledgeLibraryService.list().then((response)=>{
        this.Knowledges_list = response.data;
        this.Knowledges_list.forEach(el=>{
          el.robots = el.linked_bots_and_knowledge_set.map(item=> {return item.ai_bot_id});
          el.robots_count = el.linked_bots_and_knowledge_set.length;
          el.docs_count = el.knowledge_detial_set.length;
        })
        this.filter_knowledges_list = this.Knowledges_list;
      })
      this.getCategoryListData();
    },
    async getCategoryListData(){
      await KnowledgeLibraryService.getknowledgecategoryoption().then((response)=>{
        this.category_list = response.data;
      })
    },
    async getBotList(){
      await AiBotsService.select_list().then((response)=>{
        this.botList = response.data;
      })
      .catch(response => {
          // Redirect to PermissionError page if error status is 403
          if (response.response.status == 403)
          {
              this.$router.replace('/upgpt/PermissionError');
          }
          else if(response.response.status == 404)
          {
              this.$router.replace('/upgpt/PageNotFound');
          }
      });        
    },
    async openKnowledge(data){
      let edit_data = {
        "id" : data.id,
        "active" : !data.active
      }
      await KnowledgeLibraryService.edit(edit_data).then((response)=>{
        data.active = response.data.active;
      })
    },
    onDelete(id){
      this.deleteId = id;
      this.isDelete = true;
      this.message = i18n.t("GPT_KNOWLEDGE.DEL_MSG");
      this.messageDialog = true;
    },
    toDetail(id){
      if(!this.isDelete){
        this.$router.push(this.$route.path+"/"+id);
      }
    },
    getKnowledgeOpenNewTab() {
      PreferenceService.getKnowledgeOpenNewTab().then(response => {
        this.openKnowledgeNewTab = String(response.data).toUpperCase() === "Y";
      }).catch(() => {
        this.openKnowledgeNewTab = false;
      });
    },
    openKnowledgeDetail(id) {
      const target = `/upgpt/Knowledges/${id}`;
      if (this.openKnowledgeNewTab) {
        const { href } = this.$router.resolve(target);
        window.open(href, '_blank');
      } else if (this.$router) {
        this.$router.push(target);
      }
    },
    getFormatTime(data){
        let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',hour: '2-digit',minute: '2-digit',hour12: false };
        let today  = new Date(data);
        if(this.$i18n.locale == "zh_TW")
        {
            return today.toLocaleDateString("zh-TW", options); 
        }else
        {
            return today.toLocaleDateString("en-US", options);
        }                
    },
    onMail: function (mail) {
      return "mailto:" + mail;
    },
    // Dialog Area ----------------------------------------- [Start]
    showAddDialog() {
      this.addDialog = true;
    },
    onEmitAddDialog(val,data){
      if(val){
        if(data === "no_auth"){
          this.get_403_change_admin_to_staff();
        }else{
          data.robots = data.linked_bots_and_knowledge_set.map(item=> {return item.ai_bot_id});
          data.robots_count = data.linked_bots_and_knowledge_set.length;
          data.docs_count = data.knowledge_detial_set.length;
          this.Knowledges_list.unshift(data);
          this.loadRoot();
          this.act_search();
        }
      }
      this.selectedTreeId = null;
      this.addDialog = false;
    },
    async onEmitAddFolderDialog(val){
      this.addKBFolderDialog = false;
      if(val){
        if(val.parent_id == "Root"){
          val.parent_folder=null;
        }
        await KnowledgeLibraryService.createFolder(val)
        .then((response)=>{
          if(response.data == "same name block"){
            this.showErrorDialog(i18n.t('ADD_KNOWLEDGE_FOLDER.ERROR_3'));
            this.addBtn_loading = false;
          }
          else{
            this.loadRoot();
          }

        })
      }
      this.selectedTreeId = null;
    },
    onEmitEditFolderDialog(val){
      if(typeof val ==="string")
      {
        this.showErrorDialog(val)
        return;
      }
      else if (val){
        this.loadRoot()
      }
      this.editKBFolderDialog = false;
      this.editingKBFolder = null;
    },
    showSuccessDialog() {
      this.successDialog = true;
    },
    onEmitSuccessDialog() {
      this.successDialog = false;
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
    },
    showMessageDialog(message) {
      this.messageDialog = true;
      this.message = message;
    },
    async onEmitMessageDialog(val) {
      if(val && this.isDelete){
          await KnowledgeLibraryService.delete(this.deleteId).then(()=>{
            this.Knowledges_list = this.Knowledges_list.filter(el=>el.id != this.deleteId);
            this.loadRoot();
            this.act_search();
        })
      }
      if(val && this.delMode == 'deleteFolder') {
        await KnowledgeLibraryService.deleteFolder(this.deleteFolderData.id, this.deleteFolderData.id).then(()=>{
          this.loadRoot();
        })
      }
      this.isDelete = false;
      this.deleteId = null;
      this.selectedTreeId = null;
      this.messageDialog = false;
    },
    async act_search() {
      await this.getCategoryListData();
      // old knowledge filter
      let temp_arr = []
      this.Knowledges_list.filter(el => {
        if((this.selectCategory == null || this.selectCategory == '')&(this.selectUpdateby == null || this.selectUpdateby == '')){
          if(el.name.includes(this.libname_search)){
            temp_arr.push(el);
          }
        }else if((this.selectCategory != null & this.selectCategory != '')&(this.selectUpdateby == null || this.selectUpdateby == '')){
          if((el.name.includes(this.libname_search))&(el.category==this.selectCategory)){
            temp_arr.push(el);
          }
        }else if((this.selectCategory == null || this.selectCategory == '')&(this.selectUpdateby != null & this.selectUpdateby != '')){
          if((el.name.includes(this.libname_search))&(el.updated_by.id==this.selectUpdateby)){
            temp_arr.push(el);
          }
        }else{
          if((el.name.includes(this.libname_search))&(el.category==this.selectCategory)&(el.updated_by.id==this.selectUpdateby)){
            temp_arr.push(el);
          }
        }
      });
      this.filter_knowledges_list = temp_arr;

      // View-specific filtering
      if (this.activeView === "tree") {
        this.treeOptions = this.filterTreeForTreeselect(this.rootCardNodes);
      } else {
        const nodes = this.getNodesForCurrentFolder();
        const keyword = (this.libname_search || "").trim();
        this.cardNode = nodes.filter(n => {
          const type = n && (n.type || n.raw?.type);
          if (type === "folder") {
            if (!keyword) return true;
            return String(this.getNodeName(n)).includes(keyword);
          }
          if (type === "library") {
            return this.matchesLibraryFilters(n);
          }
          return true;
        });
      }
    },
    async refresh(){
      this.selectCategory = '';
      this.selectUpdateby = '';
      this.libname_search = '';
      await this.getListData();
      await this.loadRoot();
    },
    onMenuAddKnowledge() {
      this.menuOpen = false

      if (this.selectedTreeId || this.currentFolderId !="root") {
        const node = this.selectedTreeNode
        this.addDialogParent = node.id || null;
        this.addDialogParentPath = node.path || "/";
      }
      else{
        this.addDialogParent = null;
        this.addDialogParentPath = "/";
      }
      this.showAddDialog()
    },
    createKnowledgeFolder() {
      this.menuOpen = false;
      if (this.selectedTreeId || this.currentFolderId !="root") {
        const node = this.selectedTreeNode
        this.addFolderDialogParent = node.id;
        this.addFolderDialogParentPath = node.path || "/";
      }
      else{
        this.addFolderDialogParent = null;
        this.addFolderDialogParentPath = "/";
      }

      this.addKBFolderDialog = true;
    },
    normalizer(raw) {
      const id = raw.id;
      const name = raw.name ?? raw.system_name ?? String(raw.id);
      const rawType = raw && raw.type;
      const isLibrary = rawType === 'library';

      const node = {
        id,
        label: name,
        name,
        raw,
        path: raw.path,
        type: raw.type,
      };
      // 只有 folder/可展開的節點才提供 children
      if (isLibrary) {
        if (node.raw) delete node.raw.children;
      }
      this.nodeMap.set(id, node);
      console.log("tree", node)
      return node;
    },
    openFolder(item){
      if (!item) return;
      this.currentFolderId = item.id;
      this.cardNode = Array.isArray(item.children) ? item.children : [];
      this.breadcrumbs = this.buildBreadcrumbsToId(item.id);
    },
    async onFolderEdit(item){
      // 知識庫跳轉，編輯知識庫資料夾
      if (item && item.type === 'library') {
        this.openKnowledgeDetail(item.id);
      }else{
        let parent_id = null;
        try {
          const { data: parent_folder } = await KnowledgeLibraryService.getFolderParent(item.id);
          parent_id = parent_folder && parent_folder.parent_folder ? parent_folder.parent_folder : null;
        } catch (e) {
          parent_id = null;
        }

        this.editingKBFolder = {
          id: item.id,
          parent_id,
          name: item.name,
          path: this.getParentPath(item.path),
          perm: item.perm,
          type: item.type,
          updated_by: item.updated_by,
          updated_on: item.updated_on,
        };
        this.editKBFolderDialog = true;
      }
    },
    onFolderDelete(item){
      if(item.type=='folder'){
        this.delMode = 'deleteFolder';
        this.deleteFolderData = item;
        this.messageDialog = true;
        this.message = i18n.t('ADD_KNOWLEDGE_FOLDER.DELETE_MSG');
      }else if(item.type=='library'){
        this.onDelete(item.id);
      }
    },
    applyFullPaths(nodes, parentPath = "/") {
      if (!Array.isArray(nodes)) return nodes;

      const normalizedParent = (parentPath || "/").replace(/\/+$/g, "") || "/";
      const base = normalizedParent === "/" ? "" : normalizedParent;

      nodes.forEach(node => {
        if (!node) return;

        const segment = node.name ?? node.system_name ?? String(node.id ?? "");
        const currentPath = `${base}/${segment}`.replace(/\/+/g, "/");
        node.path = currentPath;

        if (Array.isArray(node.children) && node.children.length) {
          this.applyFullPaths(node.children, currentPath);
        }
      });
      return nodes;
    },
    checkCanView(nodes) {
      if (!Array.isArray(nodes)) return [];

      return nodes.map(node => {
          // 先遞迴過濾 children
          const filteredChildren = node.children?this.checkCanView(node.children):[];
          const canViewSelf = node.perm.can_view === true;

          // 只要自己能看 或 子層還有東西 → 保留
          if (canViewSelf || filteredChildren.length > 0) {
            return {
              ...node,
              children: filteredChildren
            };
          }

          // 否則砍掉
          return null;
        }).filter(Boolean);
    },
    async loadRoot() {
      try {
        await KnowledgeLibraryService.getFolderTree().then(response => {
          let res_data = response.data.tree;
          res_data = this.checkCanView(res_data);
          res_data = this.applyFullPaths(res_data);
          this.rootCardNodes = res_data;
          this.cardNode = res_data;
          this.treeOptions = res_data;
          console.log("加工 folder tree data",res_data)
          this.currentFolderId = "root";
          this.breadcrumbs = this.buildBreadcrumbsToId("root");
        })
      }catch(error){
        console.error('error : ', error)
      }
    }
  },
  watch:{
    "messageDialog":function(){
      if(!this.messageDialog){
        this.isDelete = false;
      }
    },
    "libname_search":function(){
      this.act_search();
    },
    "activeView":function(){
      if (this.activeView ==="tree"){
        this.currentFolderId = 'root';
        this.breadcrumbs = this.buildBreadcrumbsToId("root");
        this.loadRoot()
      }
      else{
        this.selectedTreeId = null;
      }
    }
  },
  computed: {
    folderNodes() {
      return this.cardNode.filter(n => n.type == 'folder');
    },
    kbNodes() {
      return this.cardNode.filter(n => n.type == 'library');
    },
    selectedTreeNode() {
      let node = null ;
      if (this.activeView ==="tree"){
         node = this.nodeMap.get(String(this.selectedTreeId));
      }
      else{
         node = this.nodeMap.get(String(this.currentFolderId));
      }
      if (node.raw.type === 'library') {
        node.id = node.raw.data.parent_folder
        node.path = this.getParentPath(node.raw.path)
      }
      return node
    },
  }
};
</script>
<style>
.card-area::-webkit-scrollbar {
  width: 6px; /* 調整滾動條寬度 */
}
.card-area::-webkit-scrollbar-track {
  background:  #F4F4F4 !important;
}
.card-area::-webkit-scrollbar-thumb {
  background: rgba(153, 153, 153, 0.3) ;
  border-radius: 10px;
}
.updateby-user{
  display: -webkit-inline-box;
  -webkit-line-clamp: 1; /* 部分舊版瀏覽器需要此設定 */
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  max-width: 85px;
}
.knowledge-folder-tab{
  background-color: #ffffff;
}
/* Folder grid cards */
.gap-8{
  gap: 8px;
}
.kb-card{
  width: 140px;
  padding: 12px;
  border-radius: 16px;
  background: #ffffff;
  cursor: pointer;
}
.kb-card--folder{
  position: relative;
}
.kb-card__menu{
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 2;
}
.UX-folder-card-hover{
  background: #f4f4f4;
}
.kb-card__icon{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  min-height: 72px;
}
.kb-card__name{
  width: 96px;
  margin: 0 auto;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  text-align: center;
  color: #444;
}
.cursor-pointer {
  cursor: pointer;
}
</style>